<template>
    <v-card-text class="mt-4">
        <v-row class="centrado">
            <v-flex xs12>
                <v-img
                        class="centrado ml-4 mr-4"
                        :src="require('../assets/intLogo.png')"
                        height="250px"
                        contain
                ></v-img>
            </v-flex>
            <div class="
                text-xs-center
                text-sm-center
                text-md-center
                text-lg-center
                text-xl-center">
                <br>
                <h3>{{$t('msg_password_reset')}}</h3>
            </div>
            <v-layout class="centrado" row wrap>
                <v-flex class="centrado" xs12 sm6 md4 lg3 xl2>
                    <v-text-field
                            v-model="email"
                            prepend-icon="email"
                            name="email"
                            label="E-Mail"
                            :error-messages="errores.error"
                    >
                    </v-text-field>
                </v-flex>
                <v-btn
                        color="primary"
                        class="centrado"
                        @click="reset_password()">
                    {{$t('enviar')}}
                </v-btn>
            </v-layout>
        </v-row>
    </v-card-text>
</template>

<script>
    export default {
        name: "password_reset",
        data: () => ({
            email: '',
            errores: []
        }),
        methods:{
            reset_password: function () {
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/User/Reset/Passwordsita/',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        email: this.email
                    }
                };
                axios(config)
                    .then(ok => {
                        this.$router.push({ name: 'password_reset_done'})
                    })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })

            },
        }
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
